import { render, staticRenderFns } from "./DialogPageAppealChat.vue?vue&type=template&id=19eabb23"
import script from "./DialogPageAppealChat.vue?vue&type=script&lang=js"
export * from "./DialogPageAppealChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports